module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp23_8017.e8fe4d37.png";